const ApplicationLock = ({ children }) => children;
export default ApplicationLock;
